export const getQuestionOptionLetter = (index: number) => {
  return String.fromCharCode(65 + index);
};

export const getStepValue = (value: number) => {
  if (`${value}`.length < 2) {
    return `${value}`;
  }
  return value;
};
